// Sugestão inicial do quadro de vans: regiões cabem juntas até a lotação de
// referência; uma região maior que a lotação vira várias vans, mantendo os
// bairros contíguos. A operadora ajusta a partir daqui.
const byBairro = (a, b) => String(a.bairro || '').localeCompare(String(b.bairro || ''), 'pt-BR')
  || String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR');

const chunkRegion = (region, capacity) => {
  const count = Math.ceil(region.pessoas.length / capacity);
  const people = [...region.pessoas].sort(byBairro);
  const size = Math.ceil(people.length / count);
  return Array.from({ length: count }, (_, index) => ({
    ...region,
    id: `${region.id}-${index + 1}`,
    pessoas: people.slice(index * size, (index + 1) * size),
  })).filter((item) => item.pessoas.length);
};

// Lotação de referência: a capacidade mais comum da frota (no empate, a menor).
// Um micro-ônibus isolado não deve fazer a sugestão juntar regiões demais.
export function typicalCapacity(capacities = []) {
  const counts = new Map();
  for (const value of capacities.map(Number).filter((item) => item > 0)) counts.set(value, (counts.get(value) || 0) + 1);
  if (!counts.size) return null;
  return [...counts].sort((a, b) => b[1] - a[1] || a[0] - b[0])[0][0];
}

export function packRegionsByCapacity(regions = [], capacity) {
  const cap = Number(capacity);
  if (!Number.isFinite(cap) || cap < 1) return regions.map((region) => ({ ...region, qtdVeiculos: 1 }));
  const items = regions.flatMap((region) => (region.pessoas.length > cap ? chunkRegion(region, cap) : [region]))
    .sort((a, b) => b.pessoas.length - a.pessoas.length || String(a.regiao).localeCompare(String(b.regiao), 'pt-BR'));
  const bins = [];
  for (const item of items) {
    const bin = bins.find((candidate) => candidate.count + item.pessoas.length <= cap);
    if (bin) { bin.items.push(item); bin.count += item.pessoas.length; } else bins.push({ items: [item], count: item.pessoas.length });
  }
  return bins.map(({ items: [first, ...rest] }) => (rest.length ? {
    id: `agrupado-${[first, ...rest].map((item) => item.id).join('-')}`,
    regiao: [...new Set([first, ...rest].map((item) => item.regiao))].join(' + '),
    pessoas: [first, ...rest].flatMap((item) => item.pessoas),
    qtdVeiculos: 1,
    origens: [...new Set([first, ...rest].flatMap((item) => item.origens || [item.regiao]))],
    subgrupos: null,
  } : { ...first, qtdVeiculos: 1 }));
}

// Agrupa os passageiros de uma van por bairro, na ordem em que aparecem.
export function peopleByBairro(people = []) {
  const groups = [];
  for (const person of people) {
    const name = person.bairro || 'Bairro não informado';
    let group = groups.find((item) => item.name === name);
    if (!group) { group = { name, people: [] }; groups.push(group); }
    group.people.push(person);
  }
  return groups;
}

// Pedidos da lista "A fazer" que formam a mesma viagem: mesma transportadora,
// destino, data, sentido e horário.
export function groupOrdersIntoTrips(items = []) {
  const trips = new Map();
  for (const item of items) {
    const key = [item.cliente_id, item.empresa_destino_id, String(item.data || '').slice(0, 10), item.trecho, String(item.horario || '').slice(0, 5)].join('|');
    if (!trips.has(key)) trips.set(key, { key, items: [] });
    trips.get(key).items.push(item);
  }
  return [...trips.values()].map((trip) => ({
    ...trip,
    first: trip.items[0],
    passengers: trip.items.reduce((sum, item) => sum + (Number(item.total_passageiros) || 0), 0),
  })).sort((a, b) => String(a.first.horario).localeCompare(String(b.first.horario)));
}
